import { ArrowLeft, ShieldCheck, FileText } from "lucide-react";
import { Logo } from "../components/Logo";

const CONTENT = {
  privacy: {
    icon: ShieldCheck,
    title: "Ochrana osobních údajů",
    updated: "Účinnost od 1. 9. 2026",
    testid: "privacy-page",
    sections: [
      {
        h: "1. Správce osobních údajů",
        p: [
          "Zirsen je společná značka dvou samostatně podnikajících finančních poradců, kteří jsou správci vašich osobních údajů:",
          "Raffaele Zirone, IČO: 11746858, a Ondřej Šenfeld, IČO: 19739842, oba se sídlem Hrnčířská 2456, 470 01 Česká Lípa 1.",
          "Kontakt: info@zirsen.cz, +420 608 125 907.",
        ],
      },
      {
        h: "2. Jaké údaje zpracováváme",
        list: [
          "Jméno, e-mail a telefonní číslo z rezervačního formuláře",
          "Téma nebo zprávu, kterou nám napíšete",
          "Odpovědi z Finanční analýzy (rozsah příjmů, výdajů, pojištění, úvěrů a investic)",
          "Datum, čas a forma domluvené schůzky",
        ],
      },
      {
        h: "3. Účel zpracování",
        p: [
          "Údaje používáme výhradně k vyřízení vaší poptávky, domluvení a připomenutí schůzky a k přípravě na osobní konzultaci.",
        ],
      },
      {
        h: "4. Právní základ",
        p: [
          "Zpracování probíhá na základě předsmluvního vztahu a našeho oprávněného zájmu (čl. 6 odst. 1 písm. b) a f) nařízení GDPR).",
        ],
      },
      {
        h: "5. Doba uchování",
        p: [
          "Údaje uchováváme nejdéle 3 roky od posledního kontaktu, nebo do okamžiku, kdy požádáte o jejich výmaz.",
        ],
      },
      {
        h: "6. Komu údaje předáváme",
        p: [
          "V oblasti pojištění jednáme jako vázaní zástupci Allianz pojišťovny, a. s. — údaje potřebné k sjednání pojištění předáváme pouze jí. K odesílání e-mailů využíváme technického poskytovatele e-mailových služeb. Vaše údaje nikomu neprodáváme ani neposkytujeme k marketingu třetích stran.",
        ],
      },
      {
        h: "7. Finanční analýza",
        p: [
          "Nástroj Finanční analýzy zpracovává vaše odpovědi automaticky a jeho výsledky jsou pouze orientační. Do odeslání rezervace neukládáme žádné údaje z analýzy — uloží se teprve ve chvíli, kdy si schůzku potvrdíte.",
        ],
      },
      {
        h: "8. Vaše práva",
        list: [
          "Právo na přístup k údajům a jejich opravu",
          "Právo na výmaz nebo omezení zpracování",
          "Právo vznést námitku proti zpracování",
          "Právo na přenositelnost údajů",
          "Právo podat stížnost u Úřadu pro ochranu osobních údajů (www.uoou.cz)",
        ],
      },
      {
        h: "9. Cookies",
        p: [
          "Web používá pouze technické úložiště pro zapamatování volby jazyka. Nepoužíváme analytické ani marketingové cookies.",
        ],
      },
    ],
  },
  terms: {
    icon: FileText,
    title: "Obchodní podmínky",
    updated: "Účinnost od 1. 9. 2026",
    testid: "terms-page",
    sections: [
      {
        h: "1. Úvodní ustanovení",
        p: [
          "Zirsen je společná značka samostatně podnikajících finančních poradců Raffaele Zirone (IČO: 11746858) a Ondřeje Šenfelda (IČO: 19739842), Hrnčířská 2456, 470 01 Česká Lípa 1.",
          "V oblasti pojištění jednáme jako vázaní zástupci Allianz pojišťovny, a. s.",
        ],
      },
      {
        h: "2. Rezervace schůzek",
        p: [
          "Rezervace schůzky přes web je zdarma a nezávazná. Schůzka trvá orientačně 30 minut a probíhá v kanceláři, u vás nebo online. Termín potvrdíme e-mailem a den předem jej připomeneme. Schůzku můžete kdykoliv zrušit na info@zirsen.cz nebo +420 608 125 907.",
        ],
      },
      {
        h: "3. Charakter služeb a informací",
        p: [
          "Obsah webu a ústní či písemné konzultace mají informativní charakter a nepředstavují investiční doporučení ani nabídku ve smyslu právních předpisů.",
          "Investice nejsou vklady a jejich hodnota může kolísat. Minulé výnosy nezaručují výnosy budoucí.",
        ],
      },
      {
        h: "4. Finanční analýza",
        p: [
          "Výsledky nástroje Finanční analýzy jsou automaticky generované, orientační a mohou obsahovat chyby. Nenahrazují osobní konzultaci ani konkrétní kalkulace — přesná čísla vždy ověříme společně na schůzce.",
        ],
      },
      {
        h: "5. Odpovědnost",
        p: [
          "Za škody vzniklé použitím informací z webu bez osobní konzultace neneseme odpovědnost v rozsahu povoleném zákonem. Konkrétní podmínky produktů upravují smluvní dokumentace příslušných institucí.",
        ],
      },
      {
        h: "6. Změny podmínek",
        p: [
          "Tyto podmínky můžeme změnit; aktuální znění je vždy na této stránce.",
        ],
      },
      {
        h: "7. Kontakt",
        p: [
          "Zirsen · Hrnčířská 2456, 470 01 Česká Lípa 1 · info@zirsen.cz · +420 608 125 907",
        ],
      },
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind] || CONTENT.privacy;
  const Icon = c.icon;

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#050B14] font-body text-white" data-testid={c.testid}>
      <div className="footer-grid absolute inset-0" aria-hidden="true" />
      <div className="mesh-orb orb-a absolute -left-40 top-0 h-[420px] w-[420px] rounded-full" style={{ background: "rgba(13,148,136,0.12)" }} aria-hidden="true" />
      <div className="mesh-orb orb-b absolute -right-32 bottom-0 h-[380px] w-[380px] rounded-full" style={{ background: "rgba(30,58,95,0.5)" }} aria-hidden="true" />

      <header className="relative z-10 flex items-center justify-between border-b border-teal-500/15 px-4 py-4 sm:px-8">
        <Logo variant="light" className="h-10" />
        <a href="/" data-testid="legal-back-link" className="flex items-center gap-2 text-sm font-semibold text-slate-300 transition-colors hover:text-teal-300">
          <ArrowLeft size={16} /> Zpět na web
        </a>
      </header>

      <main className="relative z-10 mx-auto max-w-3xl px-4 py-14 sm:px-6 sm:py-20">
        <div className="glass-dark rounded-2xl p-7 sm:p-10">
          <div className="flex items-center gap-3">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-teal-400/30 bg-teal-400/10 text-teal-300">
              <Icon size={20} />
            </span>
            <div>
              <h1 className="font-heading text-2xl font-extrabold tracking-tight text-white sm:text-3xl" data-testid="legal-title">{c.title}</h1>
              <p className="mt-1 font-mono text-[11px] uppercase tracking-widest text-teal-400/70">{c.updated}</p>
            </div>
          </div>

          <div className="mt-8 space-y-7">
            {c.sections.map((s, i) => (
              <section key={i}>
                <h2 className="font-heading text-base font-bold text-teal-200">{s.h}</h2>
                {s.p && s.p.map((t, j) => (
                  <p key={j} className="mt-2 text-sm leading-relaxed text-slate-300">{t}</p>
                ))}
                {s.list && (
                  <ul className="mt-2 list-disc space-y-1 pl-5 text-sm leading-relaxed text-slate-300">
                    {s.list.map((li, j) => <li key={j}>{li}</li>)}
                  </ul>
                )}
              </section>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
